import PropFirmCalendar from "../../../prop-firm-manager/PropFirmCalendar";
import { usePfmData } from "../../../prop-firm-manager/PfmDataContext";

export default function PropFirmCalendarWidget() {
  const { calendarEvents, setCalendarMonth } = usePfmData();
  return (
    <div className="h-full">
      <PropFirmCalendar events={calendarEvents} onMonthChange={setCalendarMonth} className="h-full" />
    </div>
  );
}
